// src/components/Footer.jsx
import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <p>Afaci © 2026</p>
        </footer>
    );
}

export default Footer;